import React from 'react'
import { Link as ReachRouterLink } from 'react-router-dom'

const Link = ({ to = '', ...props }) => {
  if (to.startsWith('http') || to.startsWith('mailto:')) {
    return <a href={to} {...props} />
  } else {
    return (
      <span style={{ maxWidth: 'max-content' }}>
        <ReachRouterLink to={to} {...props} />
      </span>
    )
  }
}

export default Link
